import styled from "@emotion/styled";

export const StyledAttachments = styled.div`
  .uploader {
    gap: 5px;
    align-items: center;
    .ant-avatar {
      font-size: 16px !important;
    }
  }
  .printable-image {
    display: flex;
    align-items: center;
    gap: 10px;
    .ant-image {
      overflow: hidden !important;
    }
    .loading {
      width: 50px;
      height: 50px;
    }
    .image-placeholder {
      display: flex;
      height: 50px;
      overflow: hidden;
      justify-content: center;
      align-items: center;
    }
  }
`;
